import { extendServiceContainer } from '@iotize/tap';
import { FirmwareService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    firmware: FirmwareService;
  }
}

export const _TAP_SERVICE_EXTENSION_FIRMWARE_ = extendServiceContainer(
  'firmware',
  FirmwareService,
);
